// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2uu3Q","productName":"Table_productName__2S_uQ"};